export const updateTaskAction = payload => (
  dispatch => dispatch({
    type:     UPDATE_TASK.ACTION,
    payload:  payload
  })
)

// Reducer response
export const UPDATE_TASK = {
  ACTION: 'UPDATE_TASK',

  call: ({ state, workorder, task }) => ({
    ...state,
    items: state.items.map(wo => wo.id != workorder.id ? wo : {
      ...wo,
      synced: false,
      maintenance_tasks: wo.maintenance_tasks.map(t => t.id == task.id ? task : t)
    })
  })
}
